import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import * as galleryActions from "../../actions/gallery";
import {withRouter} from 'react-router';
import { Input} from 'reactstrap';
import {Dropdown, DropdownToggle, DropdownItem, DropdownMenu} from 'reactstrap';
import * as vignetsActions from "../../actions/vignets";
import * as playlistActions from "../../actions/playlist";
import * as userActions from "../../actions/user";
import AuthService from '../../lib/AuthService';

class FilterBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search_text: '',
            sortText :'Newest',
            prjctid: '',
            prjctname:'All Project',
            dropdownOpen : false
        };
        this.Auth = new AuthService();
        this.search = this.search.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.searchPrjctVignets = this.searchPrjctVignets.bind(this);
    }

    componentDidMount() {
        if(this.props.pageName === 'VIGNETS') {

        }
        else if(this.props.pageName === 'MY_UPLOADS') {

        }
        else if(this.props.pageName === 'AUDIO') {
        }
        else if(this.props.pageName === 'VIDEO') {
        }
        this.props.getProjects({searchText : ''})
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    search(sortType,pid ='') {
        if(sortType) {
            let sortText = 'Newest';
            switch (sortType) {
                case 'new' : sortText = 'Newest';
                            break;
                case 'old' : sortText = 'Oldest';
                    break;
                case 'az' : sortText = '[A-Z]';
                    break;
                case 'za' : sortText = '[Z-A]';
                    break;
                default :sortText = 'Newest';
                    break;
            }

            this.setState({sortText:sortText, sortType:sortType})
        }
        console.log(this.props.pageName);

        if(this.state.search_text !== ''){
            this.props.updatesearchIndex();
        }
        else{
            this.props.updatesearchIndex(false);
        }
        let lastOffset =0;
        if(this.props.pageName === 'VIGNETS') {

            let data = {'vignetsList' : this.props.vignetsData.vignetsList, 'search_text' : this.state.search_text, userid: this.Auth.getProfile().user_id, 'sort' : sortType?sortType:'new', 'project_id' : pid };
            this.props.searchVignets(data);
        }
        else if(this.props.pageName === 'MY_UPLOADS' || this.props.pageName === 'AUDIO' || this.props.pageName === 'VIDEO') {
            let data = {'galleryList' : this.props.galleryData.galleryItems, 'search_text' : this.state.search_text, userid: this.Auth.getProfile().user_id, 'sort' : sortType?sortType:'new'};
            data.gal_type = this.props.pageName;
            this.props.searchGallery(data);
        }
        else if(this.props.pageName === 'PLAYLIST') {
            let data = {'playlistData' : this.props.playlistData.playListItems, 'search_text' : this.state.search_text, userid: this.Auth.getProfile().user_id, 'sort' : sortType?sortType:'new'};
            console.log("searchPlaylist");
            this.props.searchPlaylists(data);
        }
        else if(this.props.pageName === 'USER') {
            let data = {'userListData' : this.props.userListData.userList, 'search_text' : this.state.search_text, userid: this.Auth.getProfile().user_id, 'sort' : sortType?sortType:'new'};
            console.log("searchUser");
            this.props.searchUser(data);
        }
    }
    selectGridmode(){
        this.props.setViewMode('grid');
    }
    selectListmode(){
        this.props.setViewMode('list');
    }
    searchPrjctVignets(pid,pname){
        this.setState({prjctid:pid,prjctname:pname});

        this.search(this.state.sortType,pid);

    }
    setDropdownOpen = () => {
        this.setState({ dropdownOpen : !this.state.dropdownOpen})
    }
    render() {
        let prjctList = this.props.vignetsData.projectList;

        return (

            <div className="filter-block">
                <div className="filter-block-wrap">

                    <div className="sort-wraper">
                        <label>Sort by: </label>

                        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.setDropdownOpen}>
                            <DropdownToggle className="custom-drop button-adj" caret>
                                {this.state.sortText}
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu button-adj">
                                <DropdownItem className="button-adj" onClick={(e) => this.search('new')}>Newest</DropdownItem>
                                <DropdownItem className="button-adj" onClick={(e) => this.search('old')}>Oldest</DropdownItem>
                                <DropdownItem className="button-adj" onClick={(e) => this.search('az')}>[A-Z]</DropdownItem>
                                <DropdownItem className="button-adj" onClick={(e) => this.search('za')}>[Z-A]</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>

                        {/*<Dropdown>

                            <Dropdown.Toggle className="custom-drop button-adj" id="dropdownMenu3" variant="none">
                                {this.state.sortText}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu button-adj">
                                <Dropdown.Item className="button-adj" href="#/newest" onClick={(e) => this.search('new')}>Newest</Dropdown.Item>
                                <Dropdown.Item className="button-adj" href="#/oldest" onClick={(e) => this.search('old')}>Oldest</Dropdown.Item>
                                <Dropdown.Item className="button-adj" href="#/a-z" onClick={(e) => this.search('az')}>[A-Z]</Dropdown.Item>
                                <Dropdown.Item className="button-adj" href="#/z-a" onClick={(e) => this.search('za')}>[Z-A]</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>*/}
                        {/*{ this.props.pageName === 'VIGNETS' &&


                        <Dropdown>

                            <Dropdown.Toggle className="custom-drop button-adj" id="dropdownMenu3" variant="none">
                                {this.state.prjctname ? this.state.prjctname : 'All Projects'}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu button-adj">
                                <Dropdown.Item className="button-adj" onClick={(e) => this.searchPrjctVignets('0')} >All Project</Dropdown.Item>
                                {prjctList && prjctList.map((project, index) =>
                                    <Dropdown.Item className="button-adj" href="" onClick={(e) => this.searchPrjctVignets(project.project_id,project.project_name)}>{project.project_name}</Dropdown.Item>
                                )}



                            </Dropdown.Menu>
                        </Dropdown> }*/}

                        {/* <div className="dropdown custom-dropdown">
                            <label>Sort by: </label>


                            <button className="custom-drop dropdown-toggle" type="button"
                                    id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">{this.state.sortText}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenu2"
                                 x-placement="bottom-start"
                                 style={{
                                     position: 'absolute',
                                     transform: 'translate3d(46px, 34px, 0px)',
                                     top: '0px',
                                     left: '0px',
                                     'willChange': 'transform'
                                 }}>
                                <button className="dropdown-item" type="button" onClick={(e) => this.search('new')}>Newest</button>
                                <button className="dropdown-item" type="button" onClick={(e) => this.search('old')}>Oldest</button>
                                <button className="dropdown-item" type="button" onClick={(e) => this.search('az')}>[A-Z]</button>
                                <button className="dropdown-item" type="button" onClick={(e) => this.search('za')}>[Z-A]</button>


                            </div>
                        </div>*/}

                        <div className="search-block">
                            <Input type="text" name="search_text" className="search-box" placeholder="Search"
                                   onChange={this.handleInputChange} onKeyUp={(e) => this.search(this.state.sortType)}/>
                            <button className="search-btn icon-lib search-ico" onClick={(e) => this.search(this.state.sortType)}></button>
                        </div>

                    </div>
                        {(this.props.pageName === 'MY_UPLOADS' || this.props.pageName === 'AUDIO' || this.props.pageName === 'VIDEO') &&
                        <div className="left-grid-icons mob-left left-line">
                            <div className="galery-grid">
                                <button className={this.props.itemType.viewMode === 'grid' ? "glery-grid-icon icon-lib icon-grid active-in" : "glery-grid-icon icon-lib icon-grid "} onClick={(e) => this.selectGridmode(e)}></button>
                            </div>
                            <div className="galery-grid">
                                <button className={this.props.itemType.viewMode === 'list' ? "glery-grid-icon icon-lib glery-list-icon active-in" : "glery-grid-icon icon-lib glery-list-icon "} onClick={(e) => this.selectListmode(e)}></button>
                            </div>
                        </div>
                            }
                    </div>


            </div>

        );
    }
}



FilterBar.propTypes = {
    pageName: PropTypes.string
}


function mapStateToProps(state) {
    return {
        itemType  :state.gallery.galleryUpdate,
        vignetsData  :state.vignets.vignetsData,
        playlistData  :state.playlist.playlistData,
        userListData  :state.user.userListData,
        galleryData  :state.gallery.galleryData,
    };

}
export default  withRouter(connect(mapStateToProps, {
    getGalleryStatus : galleryActions.getType,
    searchVignets : vignetsActions.searchVignets,
    searchPlaylists : playlistActions.searchPlaylists,
    searchGallery : galleryActions.searchGallery,
    searchUser    : userActions.searchUser,
    setViewMode   : galleryActions.setviewMode,
    updatesearchIndex : userActions.searchIndex,
    getProjects : vignetsActions.getProjects,
    allVignetsData : vignetsActions.fetchVignetsData,
})(FilterBar));





// WEBPACK FOOTER //
// ./src/components/common/FilterBar.js